import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
	spProfilePayoutsFilterPayloadModel,
	spProfilePayoutsResponseModel,
} from 'src/app/modules/payout/models/sp-payout.models'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { TranslateService } from '@ngx-translate/core'
import { PayoutService } from '../../services/payout.service'
import { environment } from 'src/environments/environment'

@Component({
	selector: 'app-sp-payout-list',
	templateUrl: './sp-payout-list.component.html',
	styleUrls: ['./sp-payout-list.component.scss'],
})
export class SpPayoutListComponent implements OnInit {
	@Output() flipped = new EventEmitter()
	isFlipped: any = true
	subscription: Subscription = new Subscription()
	branchId: any
	imagePath = environment.attachmentPath

	spPayoutFilter: spProfilePayoutsFilterPayloadModel = {
		fromDate: null,
		toDate: null,
		payoutstatus: null,
		branchId: +this.ActivatedRoute.snapshot.params.id,
		// organizationId: 0,
		paging: { pageNumber: 1, pageSize: 10 },
	}
	totalCount = 0
	spPayouts: spProfilePayoutsResponseModel[] = []
	filterCount: number = 0
	pendingCount: number = 0
	queryParamsData: any = {
		pageNumber: '',
		pageSize: '',
		payoutId: '',
		status: '',
	}
	payoutSpDetails: any
	constructor(
		private ActivatedRoute: ActivatedRoute,
		public translate: TranslateService,
		private router: Router,
		private payoutService: PayoutService
	) {}

	ngOnInit(): void {
		this.ActivatedRoute.params.subscribe(({ id }) => {
			this.branchId = id
			this.subscription.add(
				this.ActivatedRoute.queryParams.subscribe((res) => {
					this.spPayoutFilter.paging.pageNumber = res['pageNumber'] || 1
					this.spPayoutFilter.paging.pageSize = res['pageSize'] || 10
					this.queryParamsData.payoutId = res['payoutId']
					this.queryParamsData.status = res['status']
					this.getSPPayouts()
					this.getSPPendingCount()
				})
			)
		})
	}

	getSPPayouts(filter: any = null) {
		filter
			? (this.spPayoutFilter = { ...this.spPayoutFilter, ...filter })
			: this.spPayoutFilter
		this.subscription.add(
			this.payoutService
				.getSPPayoutTransactionList(this.spPayoutFilter)
				.subscribe((res: any) => {
					this.spPayouts = res.result.items
					this.totalCount = res.result.totalCount
				})
		)
	}
	getSPPendingCount(filter: any = null) {
		filter
			? (this.spPayoutFilter = { ...this.spPayoutFilter, ...filter })
			: null

		this.subscription.add(
			this.payoutService
				.getSPPendingPayoutCount(this.spPayoutFilter)
				.subscribe((res: any) => {
					this.pendingCount = res.result
				})
		)
	}

	pagingChanged(pageNumber: number, pagecount: number) {
		this.router.navigate(['/layout/wallet/sp-wallet/' + this.branchId], {
			queryParams: {
				pageNumber: pageNumber,
				pageSize: pagecount,
			},
		})
	}

	toggle() {
		if (this.isFlipped) {
			this.flipped.emit(true)
		} else {
			this.flipped.emit(false)
		}
	}
	flipChange(id: any, status: any) {
		this.router.navigate(['/layout/wallet/sp-wallet/' + this.branchId], {
			queryParams: {
				pageNumber: this.queryParamsData.pageNumber,
				pageSize: this.queryParamsData.pageSize,
				payoutId: id,
				status: status,
			},
		})
	}
	getDetails(id: any) {
		this.subscription.add(
			this.payoutService.getServicePayoutDetails(id).subscribe((res: any) => {
				this.payoutSpDetails = res.result
			})
		)
	}
}
